export default class Hospital {
  /* ===================================
   *  CONSTRUCTOR
   * =================================== */
  constructor() {
    this.bindEvents();
  }

  /* ===================================
   *  EVENTS
   * =================================== */
  bindEvents() {
    if ($(".section-hospital-home-banner").length > 0) {
      this.HospitalHomeBannerSetup();
    }

    if ($(".hospital-home-banner-slider").length > 0) {
      this.HospitalHomeBannerSliderSetup();
    }

    if ($(".section-hospital-environment").length > 0) {
      this.HospitalEnvironmentSetup();
    }

    if ($(".section-hospital-criterias-reference").length > 0) {
      this.HospitalReferencesSetup();
      this.HospitalOtherFilesSetup();
    }

    if ($(".section-hospital-services").length > 0) {
      this.HospitalServicesSetup();
    }

    // Check if on hospital homepage and modify development slider
    if (
      $("body").hasClass("page-template-hospital-homepage") ||
      $(".section-hospital-home-banner").length > 0
    ) {
      this.HospitalDevelopmentSliderSetup();
    }
  }

  /* ===================================
   *  METHODS
   * =================================== */
  HospitalHomeBannerSetup() {
    $(".hospital-banner-slider").slick({
      fade: true,
      arrows: false,
      dots: false,
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 5000,
    });

    $(".section-hospital-home-banner .slide-next").click(function () {
      $(".hospital-banner-slider").slick("slickNext");
    });

    $(".section-hospital-home-banner .slide-prev").click(function () {
      $(".hospital-banner-slider").slick("slickPrev");
    });
  }

  HospitalHomeBannerSliderSetup() {
    const $slider = $(".hospital-home-banner-slider");
    const slideCount = $slider.find(".slide-item").length;

    // Only initialize slider if there's more than 1 slide
    if (slideCount > 1) {
      $slider.slick({
        fade: true,
        arrows: false,
        dots: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
      });

      $(".banner-slider-holder .slide-next").click(function () {
        $slider.slick("slickNext");
      });

      $(".banner-slider-holder .slide-prev").click(function () {
        $slider.slick("slickPrev");
      });
    }
  }

  HospitalEnvironmentSetup() {
    const $loadMoreBtn = $(".environment-load-more-btn");
    const $hiddenItems = $(
      ".environment-file-list .environment-file-item.hide"
    );

    // Handle load more button click
    $loadMoreBtn.on("click", function () {
      // Show all hidden items
      $hiddenItems.removeClass("hide");

      // Hide the load more button after showing all items
      $(this).parent().fadeOut(300);
    });
  }

  HospitalReferencesSetup() {
    // Handle "see more" button click for references
    $(document).on("click", ".ref-seemore-toggle", function () {
      const $btn = $(this);
      const $refList = $btn
        .closest(".ref-list, .full-col, .left-col")
        .find(".ref-list-items");
      const $hiddenItems = $refList.find(".hidden-item");

      // Show all hidden items
      $hiddenItems.removeClass("hidden-item").addClass("visible-item");

      // Hide the button immediately
      $btn.hide();
    });
  }

  HospitalOtherFilesSetup() {
    const $referenceSections = $(".section-hospital-criterias-reference");

    if ($referenceSections.length === 0) {
      return;
    }

    const refreshPdfEmbedderLayout = () => {
      window.dispatchEvent(new Event("resize"));
      $(window).trigger("resize");
    };

    const setItemState = ($item, shouldOpen) => {
      const $trigger = $item.find(".ref-item-trigger");
      const $content = $item.find(".ref-item-content");

      if ($trigger.length === 0 || $content.length === 0) {
        return;
      }

      if (shouldOpen) {
        $item.addClass("is-active");
        $trigger.attr("aria-expanded", "true");
        requestAnimationFrame(() => {
          requestAnimationFrame(refreshPdfEmbedderLayout);
        });
      } else {
        $item.removeClass("is-active");
        $trigger.attr("aria-expanded", "false");
      }
    };

    $referenceSections.find(".ref-list-items").each(function () {
      const $list = $(this);
      const $visibleItems = $list.find(".ref-item").not(".hidden-item");

      $visibleItems.each(function () {
        const $item = $(this);
        setItemState($item, false);
      });
    });

    $(document).on("click", ".ref-item-trigger", function () {
      const $currentItem = $(this).closest(".ref-item");

      if ($currentItem.hasClass("hidden-item")) {
        return;
      }

      const $list = $currentItem.closest(".ref-list-items");
      const shouldOpenCurrent = !$currentItem.hasClass("is-active");

      $list
        .find(".ref-item")
        .not(".hidden-item")
        .each(function () {
          setItemState($(this), false);
        });

      if (shouldOpenCurrent) {
        setItemState($currentItem, true);
      }
    });
  }

  HospitalServicesSetup() {
    // Handle "see more" button click for services
    const $seeMoreBtn = $("#services-see-more-btn");
    const $seeMoreHolder = $(".services-see-more-holder");
    const $servicesList = $(".hospital-services-list");

    if ($seeMoreBtn.length > 0 && $servicesList.length > 0) {
      // Check if there are hidden items based on current breakpoint
      const checkHiddenItems = () => {
        // Get all items with hide classes
        const $allItems = $servicesList.find(".hospital-service-item");
        let hasHiddenItems = false;

        // Check each item to see if it's currently hidden
        $allItems.each(function () {
          const $item = $(this);
          // Check if item has any hide class and is actually hidden
          if (
            ($item.hasClass("hide-default") ||
              $item.hasClass("hide-md-screen") ||
              $item.hasClass("hide-lg-tablet") ||
              $item.hasClass("hide-mobile")) &&
            $item.css("display") === "none"
          ) {
            hasHiddenItems = true;
            return false; // Break the loop
          }
        });

        // Show/hide button based on whether there are hidden items
        if (hasHiddenItems) {
          $seeMoreHolder.show();
        } else {
          $seeMoreHolder.hide();
        }
      };

      // Initial check
      checkHiddenItems();

      // Re-check on window resize
      let resizeTimer;
      $(window).on("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          checkHiddenItems();
        }, 250);
      });

      // Handle button click
      $seeMoreBtn.on("click", function () {
        // Get all items with hide classes
        const $hiddenItems = $servicesList.find(
          ".hospital-service-item.hide-default, " +
            ".hospital-service-item.hide-md-screen, " +
            ".hospital-service-item.hide-lg-tablet, " +
            ".hospital-service-item.hide-mobile"
        );

        // Remove all hide classes to show all items permanently
        $hiddenItems
          .removeClass("hide-default hide-md-screen hide-lg-tablet hide-mobile")
          .css("display", "flex");

        // Hide the button and its holder
        $seeMoreHolder.fadeOut(300);
      });
    }
  }

  HospitalDevelopmentSliderSetup() {
    const $developmentSlider = $(".development-list-slider");

    if ($developmentSlider.length > 0) {
      // Wait for slider to be initialized (in case Common.js hasn't run yet)
      const checkSlider = () => {
        if ($developmentSlider.hasClass("slick-initialized")) {
          // Get current settings by accessing the slick instance
          const slickInstance = $developmentSlider.slick("getSlick");
          if (slickInstance && slickInstance.options) {
            // Get current options including responsive settings
            const currentOptions = slickInstance.options;
            const responsiveSettings = currentOptions.responsive || [];

            // Destroy current slider
            $developmentSlider.slick("unslick");

            // Reinitialize with updated settings (slidesToShow: 3, keep responsive)
            $developmentSlider.slick({
              slidesToShow: 3.5,
              slidesToScroll: currentOptions.slidesToScroll || 1,
              prevArrow: currentOptions.prevArrow,
              nextArrow: currentOptions.nextArrow,
              autoplay: currentOptions.autoplay,
              autoplaySpeed: currentOptions.autoplaySpeed,
              lazyLoad: currentOptions.lazyLoad,
              responsive: [
                {
                  breakpoint: 1180,
                  settings: {
                    slidesToShow: 3.5,
                  },
                },
                {
                  breakpoint: 900,
                  settings: {
                    slidesToShow: 2,
                  },
                },
                {
                  breakpoint: 640,
                  settings: {
                    slidesToShow: 1,
                  },
                },
              ],
            });

            // Add class to slider
            $developmentSlider.addClass("single-development-gallery");
          }
        } else {
          // If not initialized yet, wait a bit and check again
          setTimeout(checkSlider, 100);
        }
      };

      // Start checking
      checkSlider();
    }
  }
}
